import Inheritable from '@nxsys/components/Inheritable';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Switch } from 'antd';
import React from 'react';
import type { PayrollFinanceSectionProps } from './types';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { IRELAND } from '@nxsys/store/constants/keys';


const CommunicationSection: React.FC<PayrollFinanceSectionProps> = ({
  form,
  watchValues,
  visibility,
}) => {
  const { messages } = useTypedIntl();
  // NX-5228: P45 and P60 are HMRC forms. Ireland abolished the P45 in 2019
  // and replaced the P60 with the Employment Detail Summary, so neither
  // toggle means anything on an Irish agency.
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);
  const isIreland = payrollCountry === IRELAND;

  if (!visibility.communication) return null;

  return (
    <div className="pt-6">
      <div className="mb-6 text-xl font-medium text-gray-800">
        {messages['common.communicationSetting']}
      </div>
      <Form.Item name={['communicationSettings', 'isSendEmailSelfBill']} wrapperCol={{ span: 24 }}>
        <Inheritable<boolean>
          label={messages['common.emailSelfBillPayslip'] as string}
          name={['communicationSettings', 'isSendEmailSelfBill']}
          value={watchValues?.communicationSettings?.isSendEmailSelfBill}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
{!isIreland && (
      <Form.Item name={['communicationSettings', 'isSendEmailP45']} wrapperCol={{ span: 24 }}>
        <Inheritable<boolean>
          label={messages['common.emailP45'] as string}
          name={['communicationSettings', 'isSendEmailP45']}
          value={watchValues?.communicationSettings?.isSendEmailP45}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
      )}
{!isIreland && (
      <Form.Item name={['communicationSettings', 'isSendEmailP60']} wrapperCol={{ span: 24 }}>
        <Inheritable<boolean>
          label={messages['common.emailP60'] as string}
          name={['communicationSettings', 'isSendEmailP60']}
          value={watchValues?.communicationSettings?.isSendEmailP60}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
      )}
    </div>
  );
};

export default CommunicationSection;
